import * as React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useQuery } from '../hooks/useQuery';
import { useForm, Controller } from 'react-hook-form';
import { FormControl } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import TextField from '@mui/material/TextField';
import InputMask from 'react-input-mask';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useSearchParams, useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { useSnackbar } from '../hooks/useSnackbar';
import SaveIcon from '@mui/icons-material/Save';
import { useAuth } from '../hooks/useAuth';
import Alert from '@mui/material/Alert';
import {
  cryptedParam,
  decryptData,
  decryptedParam,
  handleHttpError,
} from '../utils';

export const Step4Cadastro = ({
  activeStep,
  setActiveStep,
  fornecedor,
  setFornecedor,
}) => {
  const [mask, setMask] = React.useState('(99) 99999-9999');
  const [mask2, setMask2] = React.useState('(99) 99999-9999');
  const [radioValue, setRadioValue] = React.useState('clt');
  const [checkRepresentanteLegal, setCheckRepresentanteLegal] =
    React.useState(false);
  const [colaboradores, setColaboradores] = React.useState([]);
  const [colaborador, setColaborador] = React.useState();
  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm();
  const {
    cadastroStep4,
    showCadastroFornecedor,
    deletarColaborador,
    getCustomer,
    getColaborador,
  } = useQuery();
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = React.useState(false);
  const [isRascunho, setIsRascunho] = React.useState(false);
  const { isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const { user } = useAuth();

  React.useEffect(() => {
    if (searchParams.get('fornecedor_id')) {
      const fornecedor_id = decryptData(searchParams.get('fornecedor_id'));
      if (!fornecedor_id) {
        return navigate('/dashboard/listar-cadastros');
      }
      preencherFormulario(fornecedor_id);
    }
  }, []);

  const preencherFormulario = async (id) => {
    try {
      setLoading(true);
      const result = await showCadastroFornecedor(id);

      if (result && result.data && result.data.data) {
        setFornecedor(result.data.data);

        setColaboradores(result.data.data.colaboradores);
      }
      setLoading(false);
    } catch (error) {
      navigate('/dashboard/listar-cadastros');
    }
  };

  const onSubmit = (data) => {
    if (fornecedor.declaracao_enquadramento === 'MEI') {
      const representante = colaboradores.filter(
        (c) => c.representante_legal === 1,
      );

      if (representante.length >= 1 && checkRepresentanteLegal) {
        snackbar.showSnackbar(
          'Você já possui um representante legal cadastrado',
        );
        return;
      }
    }

    data.representante_legal = checkRepresentanteLegal ? 1 : 0;
    data.fornecedor_id = fornecedor.id;
    if (colaborador && colaborador.id) {
      data.id = colaborador.id;
    }
    data.tipo = radioValue;
    cadastrarColaborador(data);
  };

  const onErrors = () => {};

  const changeTipo = (value) => {
    setRadioValue(value);
  };

  const cadastrarColaborador = async (data) => {
    try {
      const result = await cadastroStep4(data);
      if (result && result.data && result.data.data) {
        setColaboradores(result.data.data);
        reset({
          nome: '',
          documento: '',
          orgao_emissor: '',
          cargo: '',
          email: '',
          telefone: '',
          telefone_adicional: '',
        });
        setColaborador(undefined);
        setCheckRepresentanteLegal(false);
      }
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    }
  };

  const onClickNext = () => {
    if (fornecedor.declaracao_enquadramento === 'MEI') {
      const representante = colaboradores.filter(
        (c) => c.representante_legal === 1,
      );

      if (representante.length === 0) {
        snackbar.showSnackbar('Insira um representante legal');
        return;
      }
    }

    setIsRascunho(false);
    setActiveStep(activeStep + 1);
  };

  const onChangeDocument = async (e) => {
    if (e.target.value.replace(/\D/g, '').length == 11) {
      const response = await getCustomer(e.target.value.replace(/\D/g, ''));
      const result = await response.json();

      if (result && result.data && result.data.id) {
        setValue('nome', result.data.name);
        setValue('telefone', result.data.phone);
        setValue('email', result.data.email);
      }
    }
  };

  const handleCheck = (event) => {
    setCheckRepresentanteLegal(event.target.checked);
  };

  const editColaborador = async (id) => {
    const result = await getColaborador(id);
    if (result && result.data && result.data.data) {
      const ColaboradorRes = result.data.data;
      setColaborador(ColaboradorRes);
      setValue('nome', ColaboradorRes.nome);
      setValue('cargo', ColaboradorRes.cargo);
      setValue('documento', ColaboradorRes.documento);
      setValue('orgao_emissor', ColaboradorRes.orgao_emissor);
      setValue('email', ColaboradorRes.email);
      setValue('telefone', ColaboradorRes.telefone);
      setValue('telefone_adicional', ColaboradorRes.telefone_adicional);
      setRadioValue(ColaboradorRes.tipo);
      setCheckRepresentanteLegal(
        ColaboradorRes.representante_legal == 1 ? true : false,
      );
    }
  };

  const deleteColaborador = async (id) => {
    const result = await deletarColaborador(id);
    if (result && result.data && result.data.data) {
      setFornecedor(result.data.data);
      setColaboradores(result.data.data.colaboradores);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onErrors)}>
      <Grid container spacing={2} padding={2}>
        <Grid container sm={12} item>
          <p style={{ fontSize: 20, width: '100%', margin: 0 }}>
            <b>Cadastrar</b>
          </p>
          <p style={{ fontSize: 16, width: '100%' }}>
            Por favor, informe os dados dos representantes/colaboradores da
            empresa
          </p>
          <Alert severity="error">
            Para os colaboradores/representantes adicionados será necessário
            comprovar vínculo através de: contrato, CTPS, declaração, ata ou
            procuração.
          </Alert>
        </Grid>

        <Grid container sm={6} item>
          <label style={{ color: '#707070' }}>CPF:</label>
          <Controller
            name="documento"
            rules={{ required: 'Campo é obrigatório' }}
            control={control}
            mask="999.999.999-99"
            render={({
              field: { onChange, onBlur, ref, value },
              fieldState: { error },
            }) => (
              <InputMask
                style={{ marginTop: '5px' }}
                mask="999.999.999-99"
                maskChar={'_'}
                value={value}
                onBlur={onBlur}
                onChange={(event) => {
                  onChange(event);
                  onChangeDocument(event);
                }}
              >
                {(inputProps) => (
                  <TextField
                    margin="normal"
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                    {...inputProps}
                    id="cpf"
                    placeholder="Digite o CPF"
                  />
                )}
              </InputMask>
            )}
          />
        </Grid>
        <Grid container sm={6} item>
          <label style={{ color: '#707070' }}>Nome:</label>
          <Controller
            name="nome"
            rules={{ required: 'Campo é obrigatório' }}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                style={{ marginTop: '5px' }}
                margin="normal"
                value={value}
                error={error}
                helperText={error && error.message}
                onChange={onChange}
                fullWidth
                placeholder="Digite o nome"
              />
            )}
          />
        </Grid>
        <Grid container sm={6} item>
          <label style={{ color: '#707070' }}>Cargo:</label>
          <Controller
            name="cargo"
            rules={{ required: 'Campo é obrigatório' }}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                style={{ marginTop: '5px' }}
                margin="normal"
                value={value}
                error={error}
                helperText={error && error.message}
                onChange={onChange}
                fullWidth
                placeholder="Digite o cargo"
              />
            )}
          />
        </Grid>

        <Grid container sm={6} item>
          <label style={{ color: '#707070' }}>E-mail:</label>
          <Controller
            name="email"
            control={control}
            rules={{
              required: 'Campo é obrigatório',
              pattern: {
                value:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Insira um e-mail válido',
              },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                style={{ marginTop: '5px' }}
                margin="normal"
                value={value}
                error={error}
                helperText={error && error.message}
                onChange={onChange}
                fullWidth
                placeholder="Digite o e-mail"
              />
            )}
          />
        </Grid>
        <Grid container sm={4} item>
          <label style={{ color: '#707070' }}>Telefone 1:</label>
          <Controller
            name="telefone"
            control={control}
            rules={{ required: 'Campo é obrigatório' }}
            mask={mask}
            render={({
              field: { onChange, ref, value },
              fieldState: { error },
            }) => (
              <InputMask
                style={{ marginTop: '5px' }}
                mask={mask}
                maskChar={'_'}
                onBlur={(e) => {
                  const v = e.target.value.replace(/\D/g, '');
                  if (v.length === 10) {
                    setMask('(99) 9999-9999');
                  } else {
                    setMask('(99) 99999-9999');
                  }
                }}
                onFocus={(e) => {
                  setMask('(99) 99999-9999');
                }}
                onChange={onChange}
                value={value}
              >
                {(inputProps) => (
                  <TextField
                    margin="normal"
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                    {...inputProps}
                    id="telefone"
                    placeholder="Digite o telefone com DDD"
                  />
                )}
              </InputMask>
            )}
          />
        </Grid>
        <Grid container sm={4} item>
          <label style={{ color: '#707070' }}>Telefone 2:</label>
          <Controller
            style={{ marginTop: '5px' }}
            name="telefone_adicional"
            control={control}
            mask={mask}
            render={({
              field: { onChange, ref, value },
              fieldState: { error },
            }) => (
              <InputMask
                mask={mask2}
                maskChar={'_'}
                onBlur={(e) => {
                  const v = e.target.value.replace(/\D/g, '');
                  if (v.length === 10) {
                    setMask2('(99) 9999-9999');
                  } else {
                    setMask2('(99) 99999-9999');
                  }
                }}
                onFocus={(e) => {
                  setMask2('(99) 99999-9999');
                }}
                onChange={onChange}
                value={value}
              >
                {(inputProps) => (
                  <TextField
                    style={{ marginTop: '5px' }}
                    margin="normal"
                    error={error}
                    helperText={error && error.message}
                    fullWidth
                    {...inputProps}
                    id="telefone2"
                    placeholder="Digite o telefone com DDD"
                  />
                )}
              </InputMask>
            )}
          />
        </Grid>
        <Grid item sm={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={checkRepresentanteLegal}
                onChange={handleCheck}
                style={{ padding: '4px' }}
              />
            }
            label={'Cadastrar como representante legal'}
          />
        </Grid>
        <Grid item sm={6}>
          <Controller
            name="tipo"
            control={control}
            defaultValue="clt"
            rules={{ required: 'Tipo required' }}
            render={({ name, onBlur, onChange, value }) => (
              <RadioGroup
                row
                value={value}
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={(e) => {
                  changeTipo(e.target.value);
                }}
              >
                <FormControlLabel
                  checked={radioValue === 'clt'}
                  value="clt"
                  control={<Radio />}
                  label="CLT"
                />
                <FormControlLabel
                  checked={radioValue === 'socio'}
                  value="socio"
                  control={<Radio />}
                  label="Sócio"
                />
                <FormControlLabel
                  checked={radioValue === 'preposto'}
                  value="preposto"
                  control={<Radio />}
                  label="Preposto"
                />
                <FormControlLabel
                  checked={radioValue === 'outros'}
                  value="outros"
                  control={<Radio />}
                  label="Outros"
                />
              </RadioGroup>
            )}
          />
        </Grid>
        <Grid item sm={6} display="flex" justifyContent="flex-end">
          <Button type="submit" variant="contained" startIcon={<AddIcon />}>
            {colaborador && colaborador.id ? (
              'Salvar'
            ) : (
              <span>
                Salvar
                <small style={{ marginLeft: 5 }}>
                  (colaborador ou representante)
                </small>
              </span>
            )}
          </Button>
        </Grid>
        {colaboradores &&
          colaboradores.length > 0 &&
          colaboradores.map((res, index) => {
            return (
              <Grid container sm={12} item>
                <div
                  style={{
                    width: '100%',
                    border: '1px solid rgb(0, 102, 158)',
                    borderRadius: 10,
                    padding: 20,
                    justifyContent: 'space-between',
                    display: 'flex',
                  }}
                >
                  <div className="">
                    <span
                      style={{ color: 'rgb(0, 102, 158)', marginRight: 20 }}
                    >
                      Acesso{index + 1}
                    </span>
                    <span>{res && res.nome}</span>
                    <span style={{ marginLeft: 10 }}>
                      {res && res.documento}
                    </span>
                    <span style={{ marginLeft: 10 }}>{res && res.email}</span>
                    {res && res.representante_legal ? (
                      <span style={{ marginLeft: 10 }}>
                        <b>Representante Legal</b>
                      </span>
                    ) : null}
                  </div>
                  <div>
                    <EditIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => editColaborador(res && res.id)}
                      color="primary"
                    />
                    <DeleteOutlinedIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => deleteColaborador(res && res.id)}
                      color="error"
                    />
                  </div>
                </div>
              </Grid>
            );
          })}
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          pt: 2,
          justifyContent: 'space-between',
          marginBottom: '-50px',
        }}
      >
        <Button
          type="buttom"
          variant="text"
          color="primary"
          style={{ marginRight: '0.5rem' }}
          onClick={() => {
            setActiveStep(activeStep - 1);
          }}
        >
          <ArrowBackIosIcon color="primary" />
          Voltar
        </Button>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            pt: 2,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="warning"
            style={{ marginRight: '0.5rem' }}
            onClick={() => {
              setIsRascunho(true);
              if (isUsuarioSebrae) {
                navigate('/dashboard/listar-cadastros');
              } else {
                if (fornecedor && fornecedor.cnpj == null) {
                  navigate(
                    `/dashboard/listar-cadastros?fornecedor=${fornecedor.cnpj}`,
                    { replace: true },
                  );
                } else {
                  navigate(
                    `/dashboard/listar-cadastros?fornecedor=${fornecedor.cpf}`,
                    { replace: true },
                  );
                }
              }
              snackbar.showSnackbar('Rascunho salvo com sucesso.');
            }}
          >
            Salvar como rascunho
            <SaveIcon />
          </Button>
          <Button
            type="button"
            variant="contained"
            disabled={colaboradores.length == 0}
            onClick={onClickNext}
          >
            Próximo
          </Button>
        </Box>
      </Box>
    </form>
  );
};
